export var isTargetBlank = function isTargetBlank(url) {
  if (url.startsWith('/')) return false;
  var internal = url.match('www.outdoorvoices.com');
  if (internal && internal[0]) return false;
  return true;
};